define('services/common/ajax/balanceApp',['app'], function (app) {
    app.factory('BalanceApp', ['$q','auiAjaxWithError','biAnalyticService', function ($q, auiAjaxWithError,biAnalyticService) {
        function curryWithbiAnalytic (url, needBIAnalyze) {
            return function (settings) {
                var defer = $q.defer();
                biAnalyticService.bianalytic(url,settings);
                auiAjaxWithError.curryOld(url)(settings).then(function(data){
                    if (auiAjaxWithError.getErrorCodeGetFunction(data)) {
                        defer.reject(data)
                    } else {
                        defer.resolve(data);
                    }
                }).catch(function(err){
                    defer.reject(err);
                });
                return defer.promise;
            };
        }
        return {
            queryTrade: curryWithbiAnalytic('huawei.trade.service.queryTrade'),//支付平台
            reportReportGateway:curryWithbiAnalytic('huawei.trade.admin.report'),//支付平台
            signName: curryWithbiAnalytic('huawei.trade.service.sign')//支付平台
        }
    }])
});
